var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 1.33325H2.99984C2.64622 1.33325 2.30708 1.47373 2.05703 1.72378C1.80698 1.97382 1.6665 2.31296 1.6665 2.66659V13.3333C1.6665 13.6869 1.80698 14.026 2.05703 14.2761C2.30708 14.5261 2.64622 14.6666 2.99984 14.6666H10.9998C11.3535 14.6666 11.6926 14.5261 11.9426 14.2761C12.1927 14.026 12.3332 13.6869 12.3332 13.3333V5.99992L7.6665 1.33325Z",
    stroke: "#28245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlue);
export default __webpack_public_path__ + "static/media/file-blue.fbdb5b55ee1a2ae2a0d8d3bcda2484d0.svg";
export { ForwardRef as ReactComponent };